<template>
  <div class="text-center">
    <a :href="NRS_GO_TERMS" target="_blank" rel="noreferrer">
      <span class="color-white">Terms and Conditions</span>
    </a>
    <span class="color-white">&nbsp;|&nbsp;</span>
    <a :href="NRS_PLUS_PRIVACY_POLICY" target="_blank" rel="noreferrer">
      <span class="color-white">Privacy Policy</span>
    </a>
    <br />
    <a v-if="!canada" :href="IDT_CCPA" target="_blank" rel="noreferrer">
      <span class="color-white">California Consumer Privacy Notice</span>
    </a>
    <br />
    <a v-if="!canada" :href="IDT_VDCPA" target="_blank" rel="noreferrer">
      <span class="color-white">Virginia Consumer Privacy Notice</span>
    </a>
  </div>
</template>

<script>
import urls from "@/urls.json";
import { mapGetters } from "vuex";

export default {
  name: "LegalLinks",
  computed: {
    ...mapGetters("store", {
      canada: "canada",
    }),
  },
  created() {
    this.NRS_GO_TERMS = urls.NRS_GO_TERMS;
    this.NRS_PLUS_PRIVACY_POLICY = this.canada
      ? urls.NRS_PLUS_PRIVACY_POLICY_CANADA
      : urls.NRS_PLUS_PRIVACY_POLICY;
    this.IDT_CCPA = urls.IDT_CCPA;
    this.IDT_VDCPA = urls.IDT_VDCPA;
  },
};
</script>
